import { render, staticRenderFns } from "./Timetable.vue?vue&type=template&id=72d4271a&"
import script from "./Timetable.vue?vue&type=script&lang=ts&"
export * from "./Timetable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports